import { useCallback, useEffect, useRef, useState } from 'react';

import dayjs from 'dayjs';
import { useSelector } from 'react-redux';

import LoadingComponent from 'components/LoadingComponent';
import { FORMAT_TIME } from 'constants/index';
import useChildren from 'hooks/useChildren';
import { useResize } from 'hooks/useResize';
import ListTime from 'pages/Users/Detail/_components/ListTime';
import { calculateWidth, handleError } from 'utils/helper';

import VideoList from './_components/VideoList';

const VideoResult = () => {
  const { me } = useSelector((state) => state.auth);
  const { childrenDetail } = useSelector((state) => state.children);

  const { getDatesHasVideo, getExerciseVideoSelection } = useChildren();
  const { width } = useResize();

  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingPassingData, setIsLoadingPassingData] = useState(false);
  const [datesHasVideo, setDatesHasVideo] = useState([]);
  const [listVideo, setListVideo] = useState([]);
  const [listTime, setListTime] = useState([]);
  const [activeIndex, setActiveIndex] = useState(-1);

  const isCallingApi = useRef(false);

  const _getDetailVideo = async (index) => {
    if (datesHasVideo[index]) {
      try {
        const report_ids = datesHasVideo[index].id;
        const response = await getExerciseVideoSelection([report_ids]);
        if (response) {
          setListVideo(response);
        }
      } catch (error) {
        handleError(error);
      } finally {
        setTimeout(() => {
          setIsLoadingPassingData(false);
        }, 500);
      }
    }
  };

  const handleActiveIndex = async (index) => {
    if (index === activeIndex) return;

    setActiveIndex(index);
    setIsLoadingPassingData(true);
    await _getDetailVideo(index);
  };

  const _getReportByDate = useCallback(async () => {
    if (me && childrenDetail?.id && !isCallingApi.current) {
      try {
        isCallingApi.current = true;
        const response = await getDatesHasVideo();

        if (response) {
          setDatesHasVideo((prev) => [...prev, ...response]);
          setListTime(response.map((item) => `(${item.type === 'VIDEO' ? 'ASE' : 'DAY'})${dayjs(item.date).format(FORMAT_TIME.FULL_DATE_TIME)}`));
        }
      } catch (error) {
        handleError(error);
      } finally {
        setTimeout(() => {
          setIsLoading(false);
        }, 500);
      }
    }
  }, [me, childrenDetail?.id]);

  useEffect(() => {
    _getReportByDate();
  }, [_getReportByDate]);

  useEffect(() => {
    if (listTime.length > 0 && activeIndex === -1) {
      handleActiveIndex(0);
    }
  }, [listTime]);

  if (isLoading) {
    return (
      <div className="w-full h-full flex justify-center items-center">
        <LoadingComponent />
      </div>
    );
  }

  return (
    <div className="flex gap-4 h-full">
      {datesHasVideo.length === 0 ? (
        <div className="w-full h-full bg-white flex justify-center items-center">データがありません</div>
      ) : (
        <>
          <div style={calculateWidth(360, 1920, width)}>
            <ListTime activeIndex={activeIndex} setActiveIndex={handleActiveIndex} listTime={listTime} />
          </div>
          <div className="!w-full !max-w-full" style={calculateWidth(1384, 1920, width)}>
            {isLoadingPassingData ? (
              <div className="w-full h-full bg-white flex justify-center items-center">
                <LoadingComponent />
              </div>
            ) : (
              <VideoList listVideo={listVideo} />
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default VideoResult;
